import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';
import { normalizeImgSrc } from '../utils';

export const buildIconWithTextB1 = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  const iconFallback = 'https://cdn.skyfastimg.com/images/2025/12/25/image-694cbe9cdc1d628b9b29178e.png';
  if (!newSection?.html) return null;
  const headingContent = `<h2 style="text-align: center;">${suggestionFields.content?.heading}</h2>`;
  const subheadingContent = `<p style="text-align: center;">${suggestionFields.content?.subheading || ''}</p>`;
  const showTitleContent = !!suggestionFields.content?.heading || !!suggestionFields.content?.subheading;
  const listItem = (suggestionFields.content?.icon_grid_items || []).map(item => {
    const icon = normalizeImgSrc(item.icon_url || iconFallback);
    const htmlText = `<h3 style="text-align: center;">${item.title ||
      ''}</h3> <p style="text-align: center;">${item.subtitle || ''}</p>`;
    return {
      image: icon,
      htmlText: htmlText,
    };
  });

  const fieldUpdate = {
    title: 'Icon With Text',
    enableAnchor: false,
    showTitleContent,
    titleContent: `${headingContent} ${subheadingContent}`,
    background: {
      color: '#ffffff',
    },
    textColor: '#000000',
    wapperItems: {
      listItem: listItem,
    },
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionIconWithTextB1(newSection.html, fieldUpdate),
  };
};

export const buildCardBadgeRivoneed = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const headingContent = `<h2 style="text-align: center;">${suggestionFields.content?.heading}</h2>`;
  const subheadingContent = `<p style="text-align: center;">${suggestionFields.content?.subheading || ''}</p>`;
  const showTitleContent = !!suggestionFields.content?.heading || !!suggestionFields.content?.subheading;
  const listItem = (suggestionFields.content?.icon_grid_items || []).map(item => {
    const icon = normalizeImgSrc(item.icon_url || '');
    const htmlText = `<h3 style="text-align: center;">${item.title || ''}</h3> <p style="text-align: center;">${
      item.subtitle
    }</p>`;
    return {
      icon: icon,
      content: htmlText,
    };
  });
  // console.log(listItem)

  const fieldUpdate = {
    cardTitle: {
      show: showTitleContent,
      content: `${headingContent} ${subheadingContent}`,
    },
    items: listItem,
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionCardBadgeRivoneed(newSection.html, fieldUpdate),
  };
};
